export var SWITCHER_OPTIONS;
(function (SWITCHER_OPTIONS) {
    SWITCHER_OPTIONS["YME"] = "yme";
    SWITCHER_OPTIONS["RACING"] = "racing";
})(SWITCHER_OPTIONS || (SWITCHER_OPTIONS = {}));
export const SWITCHER_NAME = 'select-newsletter-subscription';
